export default __webpack_public_path__ + "center-text-alignment.png";